import React from "react"
import { cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider";
import { useRenderStyling } from 'lib/hooks/useRenderStyling';


export default function TopbarRender(){

  const { mode, formatter, getElementConfig, parseApiData, getApiFeedData }:any = useTemplatePreviewCtx()
  const config = getElementConfig("topbar")

  const outerStyling = useRenderStyling("w-full h-6 flex justify-between items-center border border-solid border-neutral-700 text-xs pl-2 pr-2", "styleObj")

  return(
    <div id="mm-topbar" {...outerStyling}>
      <span>{ parseApiData("[[merchant.DBA]]").result }</span>
      <span>Case No &mdash; { parseApiData("[[rp.Chargeback.ProcessorCaseId]]").result }</span>
    </div>
  )
}